import { GetAllBones as a } from "@project-rouge/rg-core";
import { isPolygonClockwise as p } from "../../geometry-utils/is-polygon-clockwise/index.js";
import { getLevelBoundary as d } from "./index6.js";
import { getBoneBoundary as g } from "./index2.js";
import { offsetPolygon as m } from "../../geometry-utils/clipper-utils/index5.js";
import { differencePolygons as y } from "../../geometry-utils/clipper-utils/index3.js";
import { getLinesFromPolygon as B } from "../../geometry-utils/core/index9.js";
import { isLineInside as u } from "../../geometry-utils/core/index18.js";
function A(t, n, i, s = !1) {
  let o = d(t, n);
  o = p(o) ? o : o.reverse();
  let r = a(t.data.anatomy).filter((e) => !n.bones.includes(e.id) && e.floors > n.levelIndex).map((e) => g({ building: t, bone: e, level: n.levelIndex }));
  r = r.map((e) => m(e, i)), o = y(o, r)[0], r = r.map((e) => m(e, 0.1));
  let l = B(s ? o.reverse() : o);
  return r.length > 0 && (l = l.filter((e) => !r.some((f) => u(e, f)))), l;
}
export {
  A as getLevelOuterBoundary
};
//# sourceMappingURL=index7.js.map
